<div class="container-fluid">
  <div class="row mh-100vh">
    <div class="col-10 col-sm-8 col-md-6 col-lg-6 offset-1 offset-sm-2 offset-md-3 offset-lg-0 align-self-center d-lg-flex align-items-lg-center align-self-lg-stretch bg-white p-5 rounded rounded-lg-0 my-5 my-lg-0" id="login-block">
      <div class="m-auto register-login w-lg-75 w-xl-50">
        <div class="text-center mb-5"><img src="assets/images/CFN-LOGO-Validated.svg" style="width: 185px;"></div>
        <h2 class="text-center" style="font-size: 20px;line-height: 1.5;margin: 20px auto;">Réinitialisation de mot de passe<br></h2>
        <form [formGroup]="resetPasswordForm" (ngSubmit)="handleValidSubmit($event)" action="#" novalidate>
          <div class="row" *ngIf="step == 2">
            <div class="alert alert-success">
              Un lien vous a été envoyé sur votre adresse e-mail pour initialiser le mot de passe.
            </div>
            <button type="button" class="btn btn-primary btn-block" (click)="redirectToLogin()">
              <span class="btn-label">
                <i class="pi pi-unlock"></i>
              </span>Se connecter
            </button>
          </div>

          <div class="form-group" *ngIf="step == 1">
            <div class="alert alert-danger" *ngIf="errorMessage.length > 0">
              {{errorMessage}}
            </div>
            <input name="Email" formControlName="Email" class="form-control"
                   type="text" placeholder="Saisir votre e-mail"
                   [ngClass]="{ 'is-invalid': submitted && f.Email.errors }">
            <div *ngIf="submitted && f.Email.errors" class="text-danger invalid-feedback">
              <div *ngIf="f.Email.errors.required">E-mail obligatoire.</div>
              <div *ngIf="f.Email.errors.maxlength">Maximum 100 caractères.</div>
              <div *ngIf="f.Email.errors.pattern">Format invalide.</div>
            </div>
          </div>
          <div style="margin-top:10px;"></div>
          <div class="form-group" *ngIf="step == 1">
            <button class="btn btn-primary btn-block" type="button" (click)="handleValidSubmit($event)">
              <span class="btn-label">
                <i class="pi pi-save"></i>
              </span>Enregistrer
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="col-lg-6 d-flex align-items-end login-bg" id="bg-block">
      <div></div>
    </div>
  </div>
</div>
